import script from "./AllPopups.vue?vue&type=script&setup=true&lang=ts"
export * from "./AllPopups.vue?vue&type=script&setup=true&lang=ts"

import "./AllPopups.vue?vue&type=style&index=0&id=4879929c&scoped=true&lang=less"

import exportComponent from "/Users/jizhengliang/Desktop/octopus/edu/educms-vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4879929c"]])

export default __exports__